module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/1-5c04ce4eff9ea30e459e39fed93842e0.svg";